import { SmartImage } from "@/components/SmartImage";
import { Reveal } from "@/components/Reveal";

export const PageHero = ({ eyebrow, title, subtitle, image, breadcrumb }) => (
  <section className="relative flex min-h-[52vh] items-end overflow-hidden bg-forest pt-28">
    <SmartImage
      src={image}
      alt={title}
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/55 to-ink/25" />
    <div className="hero-grain absolute inset-0" />
    <div className="container-x relative z-10 pb-14 md:pb-20">
      {eyebrow && (
        <Reveal className="overline mb-4" y={20}>
          {eyebrow}
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h1 className="max-w-4xl font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white md:text-6xl">
          {title}
        </h1>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.12}>
          <p className="mt-5 max-w-2xl text-base text-white/80 md:text-lg">
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  </section>
);

export const SectionHeading = ({ eyebrow, title, description, align = "left", light = false }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <p className="overline mb-4">{eyebrow}</p>}
    <h2
      className={`font-heading text-3xl font-extrabold leading-tight tracking-tight md:text-5xl ${
        light ? "text-white" : "text-forest"
      }`}
    >
      {title}
    </h2>
    {description && (
      <p className={`mt-5 text-base md:text-lg ${light ? "text-white/75" : "text-ink/70"}`}>
        {description}
      </p>
    )}
  </div>
);

export default PageHero;
